import React from "react";
import { ICamera, ICamerasMeta } from "modules/cameras/types";
import { cameraFilter } from "modules/cameras/services";

import { remove } from "shared/services/crud";

const useCameraFilter = (companyId?: number) => {
  const [cameraFilters, setCameraFilters] = React.useState<ICamera[]>([]);
  const [cameraMeta, setCameraMeta] = React.useState<ICamerasMeta>(
    {} as ICamerasMeta
  );

  const [currentPage, setCurrentPage] = React.useState(0);
  const [loading, setLoading] = React.useState<boolean>(true);

  const getFilter = React.useCallback(async () => {
    setLoading(true);

    const { data, status } = await cameraFilter(companyId || 0, currentPage);
    if (status === 200) {
      setCameraFilters(data.data);
      setCameraMeta(data.meta);
      setCurrentPage(data.meta.current_page);
      //console.log(cameraFilters);
      setLoading(false);
    }
  }, [companyId, currentPage]);

  const deleteById = React.useCallback(
    async (id: number): Promise<unknown> =>
      remove(id).then(() =>
        setCameraFilters((cc) => ({
          ...cc,
          data: cc.filter((row: any) => row.id !== id),
        }))
      ),
    []
  );

  React.useEffect(() => {
    getFilter();
  }, [getFilter]);

  return {
    cameraFilters: cameraFilters,
    loading,
    meta: cameraMeta,
    currentPage: currentPage,
    setCurrentPage: setCurrentPage,
    deleteById,
  };
};

export { useCameraFilter };
